var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssComp,style:({
    backgroundImage: _vm.image ? ("url(" + _vm.image + ")") : '',
    minWidth: (_vm.width + "px"),
    width: (_vm.width + "px"),
    height: (_vm.height + "px"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }